import { HttpErrorResponse } from '@angular/common/http';
import { AccessoryCategory, Constants, Positions, TireFilterCategoryName, WheelFilterCategoryName } from '../core/Constants';
import { CategoryFiltersResponseDto, GenericStringValueIdCategoryFilter } from '../core/models/filter-backend';
import { ImageDetails } from '../core/models/image-details.dto-response';
import { LabourDtoResponse } from '../core/models/labour.dto-response';
import { MakeYearModel } from '../core/models/make-year-model.model';
import { PackageBuilderSummaryProduct } from '../core/models/package-builder-summary-product.model';
import { Product } from '../core/models/product.model';
import { SkuList } from '../core/models/sku-list';
import { TireCategoryFilter } from '../core/models/tire-category-filter.model';
import { TiresBySpecsParamsModel } from '../core/models/tires-by-specs-params.model';
import { WheelCategoryFilter } from '../core/models/wheel-category-filter.model';
import { WheelsBySpecsParamsModel } from '../core/models/wheels-by-specs-params.model';
//import { User } from '../core/User';
import { PackageBuilderService } from '../package-builder/package-builder.service';
import { StringValueId } from '../shared/filters/filter-supported-type.model';
import { LabourModel } from '../shared/notes/models/labour-model';
import { User } from '../core/User';
import { get } from 'https';
import { ProductCardDtoResponse } from 'app/core/models/product-card-dto-response';
import { ProductDetailsDtoResponse } from 'app/core/models/product-details.dto-response';
import { ProductCardDetailsDtoResponse } from '../core/models/product-card-details.dto-response';

export class Helper {
  static SkuList: SkuList;

  static encodeURIComponent2(value: string): string {
    return encodeURIComponent(encodeURIComponent(value).replace(/\./g, '%2E'));
  }

  static extractMakeYearModelFromRouteParam(params: { [name: string]: any }): MakeYearModel {
    const mym = new MakeYearModel();
    mym.make = params.get(Constants.MAKE_ROUTE_PARAM);
    mym.year = params.get(Constants.YEAR_ROUTE_PARAM);
    mym.model = params.get(Constants.MODEL_ROUTE_PARAM);
    mym.submodel = params.get(Constants.SUBMODEL_ROUTE_PARAM);
    mym.option = params.get(Constants.OPTIONS_ROUTE_PARAM);
    mym.isSummerSeason = Helper.extractIsSummerSeasonFromRouteParam(params); // (legacy code) isSummerSeason should not be part of mym
    mym.defaultAggressive = params.get(Constants.DEFAULT_AGGRESIVE_ROUTE_PARAM) === "1";
    mym.isConcept = Helper.extractConceptFromRouteParam(params);
    mym.country = sessionStorage.getItem("vehicleCountry") != null ? sessionStorage.getItem("vehicleCountry") : "Canada";
    return mym;
  }

  static extractWheelStaggerFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.WHEEL_STAGGER_ROUTE_PARAM);
  }

  static extractTireStaggerFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.TIRE_STAGGER_ROUTE_PARAM);
  }

  static extractWheelDefaultStaggerFromRouteParam(params: { [name: string]: any }): string {
    const defaultStaggers = params.get(Constants.DEFAULT_STAGGER_ROUTE_PARAM);
    return defaultStaggers !== null && defaultStaggers !== undefined ? defaultStaggers.substring(0, 1) : null;
  }

  static extractTireDefaultStaggerFromRouteParam(params: { [name: string]: any }): string {
    const defaultStaggers = params.get(Constants.DEFAULT_STAGGER_ROUTE_PARAM);
    return defaultStaggers !== null && defaultStaggers !== undefined ? defaultStaggers.substring(1) : null;
  }

  static extractConceptFromRouteParam(params: { [name: string]: any }): boolean {
    const concept = params.get(Constants.CONCEPT_VEHICLE_ROUTE_PARAM);
    return concept !== null && concept !== undefined && concept === '1' ? true : false;
  }

  static extractIsSummerSeasonFromRouteParam(params: { [name: string]: any }): boolean {
    return (params.get(Constants.SEASON_ROUTE_PARAM) === 'summer');
  }

  static extractStyleFinishFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.STYLE_FINISH_ROUTE_PARAM);
  }

  static extractWheelDiameterFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.WHEEL_DIAMETER_ROUTE_PARAM);
  }

  static extractWheelWidthFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.WHEEL_WIDTH_ROUTE_PARAM);
  }

  static extractWheelOptionsFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.WHEEL_OPTIONS_ROUTE_PARAM);
  }

  static extractWheelBySpecsFromRouteParam(params: { [name: string]: any }): WheelsBySpecsParamsModel {
    const model = new WheelsBySpecsParamsModel();
    if (params.has(Constants.DIAMETER_ROUTE_PARAM)) {
      model.diameter = Number(params.get(Constants.DIAMETER_ROUTE_PARAM));
    }

    if (params.has(Constants.PCD_ROUTE_PARAM)) {
      model.pcd = params.get(Constants.PCD_ROUTE_PARAM);
    }

    if (params.has(Constants.WIDTH_ROUTE_PARAM)) {
      model.width = Number(params.get(Constants.WIDTH_ROUTE_PARAM));
    }

    if (params.has(Constants.MIN_OFFSET_ROUTE_PARAM)) {
      model.minOffset = Number(params.get(Constants.MIN_OFFSET_ROUTE_PARAM));
    }

    if (params.has(Constants.MAX_OFFSET_ROUTE_PARAM)) {
      model.maxOffset = Number(params.get(Constants.MAX_OFFSET_ROUTE_PARAM));
    }

    return model;
  }

  static extractTiresBySpecsFromRouteParam(params: { [name: string]: any }): TiresBySpecsParamsModel {
    const model = new TiresBySpecsParamsModel();
    if (params.has(Constants.RIM_DIAMETER_ROUTE_PARAM)) {
      model.diameter = Number(params.get(Constants.RIM_DIAMETER_ROUTE_PARAM));
    }

    if (params.has(Constants.ASPECT_RATIO_ROUTE_PARAM)) {
      model.aspectRatio = Number(params.get(Constants.ASPECT_RATIO_ROUTE_PARAM));
    }

    if (params.has(Constants.SECTION_WIDTH_ROUTE_PARAM)) {
      model.width = Number(params.get(Constants.SECTION_WIDTH_ROUTE_PARAM));
    }

    if (params.has(Constants.SEASON_ROUTE_PARAM)) {
      model.season = params.get(Constants.SEASON_ROUTE_PARAM);
    }

    return model;
  }

  static extractWheelCategoryFiltersFromRoute(params: { [name: string]: any }): WheelCategoryFilter {
    const wheelSpecs: WheelsBySpecsParamsModel = Helper.extractWheelBySpecsFromRouteParam(params);

    const wheelCategoryFilter: WheelCategoryFilter = new WheelCategoryFilter();

    if (wheelSpecs.diameter) {
      const diameter = new GenericStringValueIdCategoryFilter();
      const stringValue = wheelSpecs.diameter.toLocaleString('en-US');
      const stringValueId = new StringValueId();
      stringValueId.id = stringValue;
      stringValueId.value = stringValue;
      diameter.values = [stringValueId];
      wheelCategoryFilter.wheelDiameter = diameter;
    }
    if (wheelSpecs.pcd) {
      const pcd = new GenericStringValueIdCategoryFilter();
      const stringValue = wheelSpecs.pcd;
      const stringValueId = new StringValueId();
      stringValueId.id = stringValue;
      stringValueId.value = stringValue;
      pcd.values = [stringValueId];
      wheelCategoryFilter.pcd = pcd;
    }
    if (wheelSpecs.width) {
      const width = new GenericStringValueIdCategoryFilter();
      const stringValue = wheelSpecs.width.toLocaleString('en-US');
      const stringValueId = new StringValueId();
      stringValueId.id = stringValue;
      stringValueId.value = stringValue;
      width.values = [stringValueId];
      wheelCategoryFilter.wheelWidth = width;
    }
    if (wheelSpecs.minOffset) {
      wheelCategoryFilter.minOffset = wheelSpecs.minOffset;
    }
    if (wheelSpecs.maxOffset) {
      wheelCategoryFilter.maxOffset = wheelSpecs.maxOffset;
    }

    return wheelCategoryFilter;
  }

  static extractTireCategoryFiltersFromRoute(params: { [name: string]: any }): TireCategoryFilter {
    const tireSpecs: TiresBySpecsParamsModel = Helper.extractTiresBySpecsFromRouteParam(params);
    const tireCategoryFilter: TireCategoryFilter = new TireCategoryFilter();

    if (tireSpecs.aspectRatio) {
      const aspectRatio = new GenericStringValueIdCategoryFilter();
      const stringValue = tireSpecs.aspectRatio.toLocaleString('en-US');
      const stringValueId = new StringValueId();
      stringValueId.id = stringValue;
      stringValueId.value = stringValue;
      aspectRatio.values = [stringValueId];
      tireCategoryFilter.aspectRatio = aspectRatio;
    }

    if (tireSpecs.diameter) {
      const diameter = new GenericStringValueIdCategoryFilter();
      const stringValue = tireSpecs.diameter.toLocaleString('en-US');
      const stringValueId = new StringValueId();
      stringValueId.id = stringValue;
      stringValueId.value = stringValue;
      diameter.values = [stringValueId];
      tireCategoryFilter.rimDiameter = diameter;
    }

    if (tireSpecs.season) {
      tireCategoryFilter.summer = tireSpecs.season === 'summer';
    }

    if (tireSpecs.width) {
      const width = new GenericStringValueIdCategoryFilter();
      const stringValue = tireSpecs.width.toLocaleString('en-US');
      const stringValueId = new StringValueId();
      stringValueId.id = stringValue;
      stringValueId.value = stringValue;
      width.values = [stringValueId];
      tireCategoryFilter.sectionWidth = width;
    }

    return tireCategoryFilter;
  }

  static extractSearchTextFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.SEARCH_TEXT_PARAM);
  }

  static extractFrontProductIdFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.PRODUCT_ID_ROUTE_PARAM);
  }

  static extractRearProductIdFromRouteParam(params: { [name: string]: any }): string {
    return params.get(Constants.PRODUCT_ID_ROUTE_PARAM_REAR);
  }

  // djb:yagni-never used
  //static numberSortFunction = function (a, b) {
  //  return a - b;
  //};

  static getLogoURL(productType: string, brand: string): string {
    if (productType && brand) {
      return `/fastco/assets/BrandLogos/${productType}/${brand.replace(/\//g, '_').replace(/ /g, '')}.png`;
    }
    return '';
  }

  static getLabourSummaries(labours: Product[], productLabours: LabourDtoResponse[])
    : PackageBuilderSummaryProduct[] {
    const summaries = new Array<PackageBuilderSummaryProduct>();
    const selectedIds = labours.map(labour => labour.id);
    const selectedLabours = productLabours.filter(labour => selectedIds.indexOf(labour.details.id) !== -1);

    selectedLabours.forEach(labour => {
      const summary = new PackageBuilderSummaryProduct();
      switch (labour.type) {
        case Constants.LABOUR_TYPE_STUDDING:
          summary.description = Constants.STUDDING_DESCRIPTION;
          break;
        case Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING:
          summary.description = Constants.MOUNTING_AND_BALANCING_DESCRIPTION;
          break;
      }

      summary.imgURL = labour.details.imageUrl;
      summary.longSKU = labour.details.id;
      summary.shortSKU = labour.details.sku;
      summary.qty = labours.find(l => l.id === labour.details.id).quantity;
      summary.retailPrice = labour.details.retailPrice;
      summary.customerPrice = labour.details.customerPrice;
      summary.totalPrice = summary.qty * summary.customerPrice;
      summaries.push(summary);
    });

    return summaries;
  }

  static getLaboursModel(packageBuilderService: PackageBuilderService, labours: LabourDtoResponse[], qty: number,
    position?: Positions): LabourModel[] {
    return labours.map(labour => {
      const labourModel = new LabourModel();
      labourModel.labour = labour;

      if (labour.type === Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING) {
        labourModel.quantity = packageBuilderService.getMountingAndBalancingQty(qty, position);
      } else {
        labourModel.quantity = qty;
      }
      return labourModel;
    });
  }

  static handleError(err: HttpErrorResponse) {
    let msg: string;
    if (err.error instanceof ErrorEvent) {
      // Handle client-side or network error
      msg = `Error(Client/Network): ${err.message}\n${err.error}\nStatus: ${err.status}\nText: ${err.statusText}`;
      console.error(msg);
      alert(msg);
    } else {
      msg = `Error(Server/Backend): ${err.message}\n\n${err.error}`;
      console.error(msg);
      alert(msg);
      msg = `?status=${err.status}&text=${err.statusText}`;
      switch (err.status) {
        case 401:
          window.location.href = Constants.LOGIN_HREF;
          break;
        case 404:
          window.location.href = Constants.ERROR_404_HREF + msg;
          break;
        default:
          window.location.href = Constants.ERROR_500_HREF + msg;
          // djb:not a good idea, results in endless loop on page load errors
          //location.reload();
          break;
      }
    }
  }

  static getCurrentSiteBrand(): string {
    let urlWithoutQueryParams = window.location.pathname.substring(1);
    const index = urlWithoutQueryParams.indexOf('/');
    if (index !== -1) {
      urlWithoutQueryParams = urlWithoutQueryParams.substring(0, index).toLowerCase();
    }
    // return "Fast-Wheels";
    return Constants.POSSIBLE_BRANDS.find(brand => urlWithoutQueryParams === brand.toLowerCase().replace(' ', '-')) || '';
  }

  static getMakeYearModelQueryParams(mym: MakeYearModel): object {
    let params = null;
    if (mym !== undefined && mym.make !== null) {
      params = {
        [Constants.MAKE_ROUTE_PARAM]: mym.make,
        [Constants.YEAR_ROUTE_PARAM]: mym.year,
        [Constants.MODEL_ROUTE_PARAM]: mym.model,
        [Constants.SUBMODEL_ROUTE_PARAM]: mym.submodel,
        [Constants.OPTIONS_ROUTE_PARAM]: mym.option,
        [Constants.SEASON_ROUTE_PARAM]: mym.isSummerSeason ? 'summer' : 'winter',
        [Constants.DEFAULT_AGGRESIVE_ROUTE_PARAM]: mym.defaultAggressive ? '1' : '0'
      }
      if (mym.isConcept)
        params[Constants.CONCEPT_VEHICLE_ROUTE_PARAM] = '1';
    }
    return params;
  }

  static removeImageDuplicates(allImages: ImageDetails[]): ImageDetails[] {
    if (Array.isArray(allImages) && allImages.length > 0) {
      const imagesMap = new Map<string, ImageDetails>();
      allImages.forEach(image => {
        // djb:hack-bypass to determine actual images/tooltips
        //  if (!imagesMap.has(image.imageUrl)) {
        imagesMap.set(image.imageUrl, image);
        //  }
      });
      return Array.from(imagesMap.values());
    }
    return [];
  }

  static labourModelToProduct(labourModel: LabourModel): Product {
    const product = new Product();
    product.id = labourModel.labour.details.id;
    product.quantity = labourModel.quantity;
    product.type = labourModel.labour.type;
    return product;
  }

  static getIsFactoryStaggeredFromFilters(filters: CategoryFiltersResponseDto<StringValueId[]>[]): boolean {
    return filters.some(f => f.name === WheelFilterCategoryName.STAGGER || f.name === TireFilterCategoryName.STAGGER);
  }

  static mergeAndRemoveDuplicateWarnings(frontWarnings: string[], rearWarnings?: string[], removeWarnings?: string): string[] {
    const warnings = new Array();
    // djb:bug/hack-not really sure what this is attempting to do, override until we know how this should actually work
    //if (frontWarnings) {
    //  frontWarnings.forEach(function (frontWarning, index, wanings) {
    //    const n = frontWarning.indexOf(":") + 1;
    //    const str = frontWarning.substring(0, n);
    //    if (!removeWarnigs || removeWarnigs.indexOf(str) < 0) {
    //      warnings.push(frontWarning.replace(str, ''));
    //    }
    //  }
    //  );
    //}
    //if (rearWarnings) {
    //  rearWarnings.forEach(warning => {
    //    if (!warnings.find(w => w === warning)) {
    //      warnings.push(warning);
    //    }
    //  });
    //}
    if (frontWarnings) {
      frontWarnings.forEach(function (frontWarning, index, wanings) {
        if (frontWarning != null) {
          const n = frontWarning.indexOf(":") + 1;
          const str = frontWarning.substring(0, n);
          if (!removeWarnings || removeWarnings.indexOf(str) <= 0) {
            warnings.push(frontWarning.replace(str, ''));
          }
        }
      }
      );
    }
    if (rearWarnings) {
      rearWarnings.forEach(function (rearWarning, index, wanings) {
        if (rearWarning != null) {
          const n = rearWarning.indexOf(":") + 1;
          const str = rearWarning.substring(0, n);
          if (!removeWarnings || removeWarnings.indexOf(str) <= 0) {
            warnings.push(rearWarning.replace(str, ''));
          }
        }
      }
      );
    }
    var uniqueWarnings = warnings.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
    return uniqueWarnings;
  }

  static extractHexSizesFromDescription(description: string): string[] {
    return description.match(/-(\d+\/*)+mm/)[0].replace('mm', '').replace('-', '').split('/');
  }

  static flowToNextTab(skipOver: number = 0) {
    Helper.log('helper.flowToNextTab, skipOver=' + skipOver );
    const nextTabParent = $('.b2b-nav-tabs li a.activePBFlow').parent('li').nextAll(":visible").get(skipOver);
    const nextTab = nextTabParent.id.replace('Parent', '');
    //sessionStorage.setItem('i18n.helper.FlowToNextTab', nextTab)
    document.getElementById(nextTab).click();
  }

  static flowToSelectedTab(elementId: string) {
    Helper.log('helper.flowToSelectedTab');
    document.getElementById(elementId).click();
  }

  static setActiveTabState(elementId: string) {
    const tabsHighlighted = document.getElementsByClassName("activePBFlow");
    [].forEach.call(tabsHighlighted, function (el) {
      el.classList.remove("activePBFlow");
    });
    const element = document.getElementById(elementId);
    if (element) {
      element.classList.add("activePBFlow");
      Helper.activeTab = elementId;
      //sessionStorage.setItem("i18n.helper.SetActiveTabState", element.id)
      Helper.log(`setActiveTabState: elementId ${elementId} activePBFlow`);
    }
  }

  static get activeTab(): string {
    return sessionStorage.getItem("activeTab");
  }

  static set activeTab(elementId: string) {
    //sessionStorage.setItem("i18n.helper.activeTab", elementId);
    sessionStorage.setItem("activeTab", elementId);
  }

  static setTabVisibility(category: AccessoryCategory, show: boolean) {
    if (category === AccessoryCategory.TireValves)
      document.getElementById('tvaParent').style.display = show ? "block" : "none";
    else if (category === AccessoryCategory.OptionalValves)
      document.getElementById('valParent').style.display = show ? "block" : "none";
  }

  static renameKeyTab(keysRequired: boolean): string {
    if (keysRequired !== true)
      return 'FC.PackageBuilder.Keys.Optional';
    else
      return 'FC.PackageBuilder.Keys';
  }

  //djb:debug-speed up debugging cycle and bypass noise from image 404 errors
  private static isDevModeOnLocalHost(): boolean {
    const url = window.location.href.toLowerCase();
    // djb:note-visual studio on local machine only
    if (url.includes("localhost:")) {
      return true;
    }
    // djb:yagni-secret query string
    //if (url.includes("&localhost")) {
    //	return true;
    //}
    // djb:warn-in production always return false
    return false;
  }

  // djb:yagni-log overloads to isolate service duplication by id
  //public static log2(msg: string, caller?: HardwareService): void;
  //public static log2(msg: string, caller?: PackageBuilderComponent): void;
  //public static log2(msg: string, caller?: PackageBuilderService): void;
  //public static log2(msg: string, caller?: any): void {
  //  var prefix: string = "";
  //  if (typeof caller == 'object') {
  //    this.log(`${caller.__proto__.constructor.name}[${caller.id}].`);
  //  } else {
  //    this.log(msg);
  //  }
  //}

  public static log(msg: string): void {
    if (!this.isDevModeOnLocalHost()) {
      return
    }
    var prefix: string = '';
    // djb:debug-isolate specific msgs to reduce log noise
    var isolate: string = msg.toLowerCase();
    // djb:debug-indent nav specific messages
    if (isolate.includes('naviga')) {
      prefix = '---' + prefix;
    }
    msg = `${prefix}${msg}`;
    //if (isolate.includes('syntax')) {
    //  alert("Syntax Error");
    //}
    //}
    // djb:debug-isolate specific message(s)
    //if (isolate.includes('changetab')
    //  || isolate.includes('setpackagebuilderflow')
    //  || isolate.includes('setactive')
    //) {
    console.log(msg);
    //}
  }

  static generateId(parts: number): string {
    const array = [];
    for (let i = 0; i < parts; i++) {
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      array.push(S4);
    }
    return array.join('-');
  }

  static convertToProductDetailsDtoResponse(card: ProductCardDtoResponse, productType: string, brand: string, brandLogo: string): ProductDetailsDtoResponse {
    if (card != null) {
      let response = new ProductDetailsDtoResponse();
      response.title = card.title;
      response.shortSKU = card.shortSKU;
      response.longSKU = card.longSKU;
      response.pairNo = card.pairNo;
      response.productType = productType;
      response.productBrand = brand;
      response.retailPrice = card.retailPrice;
      response.customerPrice = card.customerPrice;
      response.specialPrice = card.specialPrice;
      response.productImages = new Array<ImageDetails>();
      if (card.productImage != null)
        response.productImages.push(card.productImage);
      response.iconUrl = card.iconUrl;
      response.details = card.details.details;
      response.isNew = card.isNew;
      response.isPreLaunch = card.isPreLaunch;
      response.isSpecial = card.isSpecial;
      response.confirmedFitment = card.confirmedFitment;
      response.labours = card.labours;
      response.isDirectFit = card.isDirectFit;
      response.isAggressiveFitment = card.isAggressiveFitment;
      response.isDrilled = card.isDrilled;
      response.icons = card.icons;
      response.inventory = card.inventory;
      response.onHandDetails = card.onHandDetails;
      response.isBlem = card.isBlem;
      response.isWinterWheel = card.isWinterWheel;
      response.warningNotes = card.warningNotes;
      response.pcd = card.pcd;
      response.brandLogo = brandLogo;
      response.hasAlternateWarehouseMtl = card.hasAlternateWarehouseMtl;
      response.hasAlternateWarehouseCal = card.hasAlternateWarehouseCal;
      response.extensionCapRequired = card.extensionCapRequired;
      return response;
    }
    return null;
  }
  static isProductTypePreferenceTire(): boolean {
    return sessionStorage.getItem("productTypePreference") === "Tire";
  }

  static stringFormat(template: string, ...args: any[]) {
    return template.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
        ;
    });
  }

  static showTorontoFirst(): boolean {
    var showTorontoFirst = sessionStorage.getItem("showTorontoFirst");
    if (showTorontoFirst !== null && showTorontoFirst === "true")
      return true;
    return false;
  }

  static isSteelProduct(productDetails: ProductDetailsDtoResponse | ProductCardDetailsDtoResponse): boolean {
    // Optional chaining operator not recognized by TypeScript version 3.5.3:
    //return productDetails?.details?.some(d => d.label === "FC.ProductDetail.Label.ConstructionType" && /steel|acier/i.test(d.value)) ?? false;
    if (productDetails && productDetails.details)
      return productDetails.details.some(d => d.label === "FC.ProductDetail.Label.ConstructionType" && /steel|acier/i.test(d.value));
    return false;
  }
}


